import {Spinner, Text} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet, View} from 'react-native';
import {renderIf} from '../../utils/Utils';
export default class AppBaseScreen extends React.Component {
  constructor() {
    super();
    this.state = {
      loader: false,
      errorMessage: '',
      visible: false,
    };
  }
  showLoader = () => {
    this.setState({loader: true});
  };
  showErrorMessage = (val, message) => {
    this.setState({visible: val, errorMessage: message});
  };
  renderErrorMessage = () => (
    <View style={styles.errorMessage}>
      <Text>{this.state.errorMessage}</Text>
    </View>
  );
  renderLoader = () =>
    renderIf(
      this.state.loader,
      <View style={styles.loader}>
        <Spinner status="basic" size="giant" />
        <Text style={styles.spinnerText}>Loading</Text>
      </View>,
    );
}
const styles = StyleSheet.create({
  loader: {
    width: 150,
    height: 50,
    backgroundColor: '#333',
    position: 'absolute',
    top: '45%',
    left: '35%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
  },
  spinnerText: {
    padding: 2,
    fontWeight: '700',
    color: '#fff',
  },
});
